/* eslint-disable no-use-before-define,no-mixed-operators */
import React from 'react'
import { AppContextProvider, useAppContext } from './App-context'
import { Loading } from '../twd'
import Header from '../header'
import Footer from '../footer'
import Content from './content'
import Framed from '../framed'
import Modal from './modal'
import Flyout from './flyout'

export { useAppContext }

export default () => {
    return <React.Fragment>
        <AppContextProvider>
        <App/>
        </AppContextProvider>
    </React.Fragment>
}

const App = () => {
    const {status, is401} = useAppContext()
    return <React.Fragment>
    { is401 && <Show401 /> }
    { !is401 && <Loading status={status}><MainApp /></Loading> }
    </React.Fragment>
}

const Show401 = () => <div className="container">
    <div className="row">
    <div className="col-md-12 text-center">
    Session has expired. Please relogin.
    </div>
    </div>
</div>


const MainApp = () => {
    const {view, args, modal, modalArgs, modal2, modal2Args} = useAppContext()

    return <React.Fragment>
    <main id="main" className="layout">
    <Header />
    <Content view={view} args={args} />
    <Framed view={view} args={args} />

    <Footer />
    <Modal view={modal} args={modalArgs} view2={modal2} args2={modal2Args} />
    <Flyout />
    </main>
    </React.Fragment>
}
